import { useMutation, useQueryClient } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';
import { toast } from 'react-toastify';

export const useUpdateTopics = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data = []) => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      return handleRequest(
        'put',
        `facility/${user.facility}/topics`,
        true,
        data,
      );
    },
    {
      onSuccess: async () => {
        toast('Topics were successfully updated', {
          type: 'success',
          style: { width: 'auto' },
        });
        queryClient.invalidateQueries(cacheKeys.getTopics());
      },
      onError: async (err) => {
        toast('Unable to update Topics', {
          type: 'error',
          style: { width: 'auto' },
        });
        console.error(
          `Failed to update Topics: ${
            err.response?.data.message || err.message
          }`,
        );
      },
    },
  );

  return mutation;
};
